module.exports = __webpack_public_path__ + "static/media/canallightitalic.81a2d2b7.woff2";